// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2YHhB","content":"RecentSearches_content__2JD19"};